<template>
    <template>
        <a-config-provider :theme="{components: {Radio: {colorPrimary: '#000',},},}"/>
    </template>

    <a-spin tip="Carregando..." :spinning="spinning">
        <div class="container">
            <a-card>
                <template #title>
                    <a-breadcrumb separator=">">
                        <a-breadcrumb-item>
                            <FileOutlined/>
                            <a href="/viabilidade/types-service"><span>Tipos de serviço</span></a>
                        </a-breadcrumb-item>
                        <a-breadcrumb-item>
                            {{ isEditMode ? 'Editar Tipo de serviço' : 'Cadastrar Tipo de serviço' }}
                        </a-breadcrumb-item>
                    </a-breadcrumb>
                </template>
                <a-row>
                    <a-col :span="2">
                        <strong>Sigla:</strong>
                    </a-col>
                    <a-col :span="8">
                        <a-space>
                            <a-input v-model:value="currentTypeService.acronym" style="width: 250px"/>
                        </a-space>
                    </a-col>
                    <a-col :span="2">
                        <strong>Descrição:</strong>
                    </a-col>
                    <a-col :span="12">
                        <a-space>
                            <a-input v-model:value="currentTypeService.description" style="width: 350px"/>
                        </a-space>
                    </a-col>
                </a-row>
                <a-row style="margin-bottom:10px; margin-top:30px">
                    <h4>Códigos do CNAE:</h4>

                    <a-col :span="24" style="display:block">
                        <a-tooltip title="Selecione os códigos CNAE desejados">
                            <a-tree-select
                                v-model:value="currentTypeService.cnaeIds"
                                :tree-data="treeData"
                                :loading="cnaeLoading"
                                multiple
                                tree-checkable
                                show-search
                                treeNodeFilterProp="title"
                                :max-tag-count="5"
                                :show-checked-strategy="SHOW_CHILD"
                                :placeholder="cnaeLoading ? 'Carregando CNAEs...' : 'Selecionar CNAE'"
                                style="width:100%"
                                :searchValue="search"
                                @search="handleSearch"
                                :open="dropdownVisible"
                                @select="handleDropdownSelect"
                                @dropdownVisibleChange="handleDropdownVisibleChange"
                            >
                                <template #tagRender="{ label, closable, onClose }">
                                    <a-tag :closable="closable" color="blue" style="margin-right:3px" @close="onClose">
                                        {{ label }}
                                    </a-tag>
                                </template>

                                <template #title="{ title, dataRef }">
                                <span
                                    :style="{
                                    fontWeight: dataRef.className === 'cnae-parent' ? 'bold' : 'normal',
                                    color: dataRef.className === 'cnae-parent' ? '#000' : '#3a3a3a',
                                    minHeight: '36px',
                                    lineHeight: dataRef.className === 'cnae-parent' ? '30px' : '24px',
                                  }"
                                >
                                  {{ title }}
                                </span>
                                </template>
                            </a-tree-select>
                        </a-tooltip>
                    </a-col>
                </a-row>
                <a-row style="margin-top: 20px">
                    <a-col :span="24" style="display:flex; justify-content:space-between; margin-bottom:10px">
                        <h4 style="margin-bottom:0; vertical-align:center">Zoneamentos:</h4>

                        <a-space style="padding-right: 40px">
                            <a-tooltip title="Marcar todos como Permitido">
                                <div style="background-color:#00bc00" class="markAllBtn" @click="markAll('allowed')">
                                    <CheckCircleOutlined/>
                                </div>
                            </a-tooltip>
                            <a-tooltip title="Marcar todos como Permissível">
                                <div style="background-color:#ffff23" class="markAllBtn"
                                     @click="markAll('permissible')">
                                    <ExclamationCircleOutlined/>
                                </div>
                            </a-tooltip>
                            <a-tooltip title="Marcar todos como Proibido">
                                <div style="background-color:#ff2c2c" class="markAllBtn" @click="markAll('prohibited')">
                                    <StopOutlined/>
                                </div>
                            </a-tooltip>
                        </a-space>
                    </a-col>

                    <a-col :span="24" style="margin-bottom:15px">
                        <div class="shadow-sm border" style="border-radius:15px; overflow:hidden">
                            <div
                                v-for="zone in currentTypeService.zones" :key="zone.id"
                                class="zonesStyle center-flex">
                                <div>{{ zone.label }}</div>

                                <div class="center-flex">
                                    <div v-if="errors[zone.id]" style="color:red; margin-right:5px;">
                                        {{ errors[zone.id] }}
                                    </div>
                                    <a-radio-group v-model:value="zone.type_permission">
                                        <a-tooltip title="Permitido" :mouseLeaveDelay="0">
                                            <a-radio value="allowed" class="radioOption" style="background-color: #00bc00">
                                                <CheckCircleOutlined style="vertical-align:middle;font-size:16px"/>
                                            </a-radio>
                                        </a-tooltip>
                                        <a-tooltip title="Permissível" :mouseLeaveDelay="0">
                                            <a-radio value="permissible" class="radioOption" style="background-color: #ffff23">
                                                <ExclamationCircleOutlined style="vertical-align:middle;font-size:16px"/>
                                            </a-radio>
                                        </a-tooltip>
                                        <a-tooltip title="Proibido" :mouseLeaveDelay="0">
                                            <a-radio value="prohibited" class="radioOption" style="background-color: #ff2c2c">
                                                <StopOutlined style="vertical-align:middle;font-size:16px"/>
                                            </a-radio>
                                        </a-tooltip>
                                    </a-radio-group>
                                </div>
                            </div>
                        </div>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="16" style="display:flex;gap:5px">
                        <a-tooltip :title="isEditMode ? 'Salvar Alterações' : 'Salvar'">
                            <a-button size="large" type="primary" @click="save" class="center-flex">
                                <template #icon>
                                    <SaveOutlined style="font-size: 18px;"/>
                                </template>
                            </a-button>
                        </a-tooltip>
                    </a-col>
                </a-row>
            </a-card>
        </div>
    </a-spin>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import {FileOutlined, SaveOutlined, CheckCircleOutlined, ExclamationCircleOutlined, StopOutlined} from '@ant-design/icons-vue';
import {notification, TreeSelect} from 'ant-design-vue';
import "codemirror/mode/htmlmixed/htmlmixed";
import "codemirror/theme/neat.css";
import { openNotification } from "../../../../utils/utilities";

const errors = reactive({})
const props = defineProps({typeService: {}});
const isEditMode = ref(!!props.typeService);
const spinning = ref(false);
const cnaeLoading = ref(false);
const cnaeLoaded = ref(false);
const treeData = ref([])
const SHOW_CHILD = TreeSelect.SHOW_CHILD
const search = ref('')
const dropdownVisible = ref(false)
const route = '/api/viabilidade/types-service';

const currentTypeService = ref({
    id: null,
    acronym: '',
    description: '',
    cnaeIds: [],
    zones: []
})

const markAll = (status) => {
    currentTypeService.value.zones.forEach(zone => {
        zone.type_permission = status
    })
}

const loadZones = async () => {
    let zones = (await window.axios.get('/api/viabilidade/zoneamentos')).data.data

    if (props.typeService) {
        const labelMap = new Map(zones.map(zone => [zone.id, `${zone.description.toUpperCase()} - ${zone.objective}`]))

        currentTypeService.value.zones = currentTypeService.value.zones.map(zone => ({
            ...zone,
            label: labelMap.get(zone.id)
        }))
    } else {
        currentTypeService.value.zones = zones.map(zone => {
            return {
                id: zone.id,
                label: zone.description.toUpperCase() + " - " + zone.objective,
                type_permission: null
            }
        })
    }
}

const buildCnaeTree = (classes, subclasses) => {
    const subclassesByClass = new Map()

    for (const sub of subclasses) {
        const classId = String(sub?.classe?.id ?? '')
        if (!classId) continue

        if (!subclassesByClass.has(classId)) {
            subclassesByClass.set(classId, new Map())
        }

        const unique = subclassesByClass.get(classId)
        if (!unique.has(sub.id)) {
            unique.set(sub.id, sub)
        }
    }

    return classes
        .slice()
        .sort((a, b) => String(a.id).localeCompare(String(b.id)))
        .map((classe) => {
            const id = String(classe.id)
            const uniqueSubclasses = Array.from(subclassesByClass.get(id)?.values() ?? [])

            return {
                title: `${id} - ${classe.descricao}`,
                value: id,
                key: id,
                className: 'cnae-parent',
                children: uniqueSubclasses.map((sub) => ({
                    title: `${sub.id} - ${sub.descricao}`,
                    value: String(sub.id),
                    key: String(sub.id),
                    className: 'cnae-child',
                })),
            }
        })
}

const loadCnaeTree = async () => {
    if (cnaeLoaded.value || cnaeLoading.value) {
        return
    }

    cnaeLoading.value = true

    try {
        const [classesResponse, subclassesResponse] = await Promise.all([
            window.axios.get('/proxy/ibge/cnae/classes'),
            window.axios.get('/proxy/ibge/cnae/subclasses'),
        ])

        const classes = Array.isArray(classesResponse.data) ? classesResponse.data : []
        const subclasses = Array.isArray(subclassesResponse.data) ? subclassesResponse.data : []

        if (classes.length === 0) {
            openNotification('warning', 'Não foi possível carregar as classes CNAE.')
            return
        }

        treeData.value = buildCnaeTree(classes, subclasses)
        cnaeLoaded.value = true
    } catch (e) {
        console.warn('Erro ao carregar CNAEs', e)
        openNotification('warning', 'Não foi possível carregar a lista de CNAEs.')
    } finally {
        cnaeLoading.value = false
    }
}

const handleSearch = (val) => {
    search.value = val
}

const handleDropdownSelect = () => {
    dropdownVisible.value = true
}

const handleDropdownVisibleChange = (visible) => {
    dropdownVisible.value = visible

    if (visible) {
        loadCnaeTree()
    }
}

const save = async () => {
    Object.keys(errors).forEach(k => delete errors[k])

    let hasError = false

    currentTypeService.value.zones.forEach(zone => {
        if (!zone.type_permission) {
            errors[zone.id] = 'Selecione uma permissão'
            hasError = true
        }
    })

    if (hasError) return

    let {id, ...data} = currentTypeService.value
    try {
        spinning.value = true;
        const response = (!id) ? await window.axios.post(route, data) : await window.axios.put(route + `/${id}`, data);
        spinning.value = false
        openNotification('success', response.data.message)
        await (new Promise(resolve => setTimeout(resolve, 500)));
        window.location.href = `/viabilidade/types-service/`
    } catch (error) {
        spinning.value = false
        openNotification('error', error.message)
    }
}

onMounted(async () => {
    try {
        spinning.value = true

        if (props.typeService) {
            currentTypeService.value = (await window.axios.get(`${route}/${props.typeService.id}`)).data.data
            isEditMode.value = true
        }

        await loadZones()
    } catch (error) {
        openNotification('error', error.message)
    } finally {
        spinning.value = false
    }

    loadCnaeTree()
})
</script>

<style scoped>
.center-flex {
    display: flex;
    justify-content: center;
    align-items: center;
}

.zonesStyle {
    display: flex;
    justify-content: space-between;
    padding: 10px 10px;
    transition: background-color 0.2s linear;
    cursor: default;
    background-color: #ececec;
}

.zonesStyle:nth-child(even) {
    background-color: #e4e4e4;
}

.zonesStyle:hover {
    background-color: #8bc6fd;
}

.markAllBtn {
    padding: 3px 16px;
    border-radius: 20px;
    cursor: pointer;
}

.radioOption {
    padding: 2px 5px;
    border-radius: 20px;
}
</style>